$(document).ready(function() {
    var videoSrc = $(".iframe-modal iframe").attr("src");

    $('.iframe-modal').on('show.bs.modal', function () { // on opening the modal
        // set the video to autostart
        $(".iframe-modal iframe").attr("src", videoSrc+"&amp;autoplay=1");
    });

    $(".iframe-modal").on('hidden.bs.modal', function (e) { // on closing the modal
        // stop the video
        $(".iframe-modal iframe").attr("src", null);
    });
});